/**
 * @module app.bdc.reports.resiliationCtrl
 *
 */
define(['angular', 'moment'], function(angular, moment) {


    function ResiliationCtrl($scope, $rootScope) {
        var self = {};
        self.client = $rootScope.order.client;

        /**
         * Get the date of the day
         * @return {String}
         */
        self.getDate = function getDate() {
            return moment().format('DD/MM/YYYY');
        };

        return self;
    }

    ResiliationCtrl.$inject = ['$scope', '$rootScope'];

    angular.module('app.bdc.reports.resiliationCtrl', []).controller('ResiliationCtrl', ResiliationCtrl);
});
